import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import {
  AppointmentDataService,
  AppointmentModel,
  CustomFieldService,
  Facility,
  InvoiceModel,
  NOT_FOUND,
  Patient,
  PatientDataService,
  PatientPalRestError,
  ResourceType,
} from '@mmx/shared'
import { isString, keys } from 'lodash'
import { of, Subject, throwError } from 'rxjs'
import { catchError, takeUntil, tap } from 'rxjs/operators'

@Component({
  selector: 'mmx-appointment-card',
  templateUrl: './appointment-card.component.html',
  standalone: false,
})
export class AppointmentCardComponent implements OnInit, OnDestroy {
  facility: Facility
  appointment: AppointmentModel
  invoice: InvoiceModel
  patient: Patient
  resourceTypes: ResourceType[] = [
    'provider',
    'modality',
    'room',
    'equipment',
    'bodyPart',
    'other',
  ]
  showMetadata = false
  keys = keys
  isString = isString

  private onDestroy$ = new Subject<void>()

  constructor(
    public data: AppointmentDataService,
    public customFields: CustomFieldService,
    private patientDataService: PatientDataService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  public ngOnInit() {
    this.patientDataService.patient$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((patient) => (this.patient = patient))

    this.data.appointment$
      .pipe(
        takeUntil(this.onDestroy$),
        tap((appointment) => {
          this.appointment = appointment
          this.facility = appointment.location
        }),
        catchError((err: PatientPalRestError) => {
          if (err.status === NOT_FOUND) {
            this.route.parent.params.subscribe((p) => {
              this.router.navigate([`/patient/${p.patientId}`])
            })
            return of(null)
          } else {
            return throwError(() => err)
          }
        }),
      )
      .subscribe()
  }

  getResourcesByType(type: ResourceType) {
    if (this.appointment && this.appointment.resources) {
      return this.appointment.resources.filter((r) => r.type === type)
    }
  }

  public ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
